import React, {useState,useEffect} from "react";
import { User, Users, CreditCard, Phone, User2, User2Icon, Image, DatabaseIcon } from "lucide-react";
import TopBar from "./../../components/TopBar";
import './../css/Profile.css';
import axios from './../../axios';
const StaffProfile = ({ setSideBar, setSettingDrawer }) => {
  // Placeholder data; replace with dynamic data from your backend
  
    const [staff,setstaff] = useState(JSON.parse(localStorage.getItem('staff')));
    const school = JSON.parse(localStorage.getItem('school'));
//    console.log('dsad'+JSON.parse(localStorage.getItem('staff')));

useEffect(() => {
  const fetchProfile = async () => {
    try {
 
      const response = await axios.get('teacher/profile', {
        params: {
          id: staff.id
        },
      });
 
      console.log(response.data);
      setstaff(response.data);
        localStorage.setItem("staff", JSON.stringify(response.data));

    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };

  fetchProfile();
}, []);
 const safeValue = (value) => {
  return value && value.trim() !== '' ? value : '--';
};

const profileData = {
  class: safeValue(staff.class),
  fatherName: safeValue(staff.fname),
  motherName: safeValue(staff.mname),
  aadharNumber: safeValue(staff.adhar),
  mobileNumber: safeValue(staff.mobile),
  inchargeNumber: safeValue(staff.incharge_mobile),
  incharge: safeValue(staff.incharge),
};


  return (
    <>
      <TopBar title="Profile" setSideBar={setSideBar} setSettingDrawer={setSettingDrawer} />
      <div className="profile-container">
        <div className="profile-header">
          <User2 size={20} className="header-icon" />
          <h2>Staff Profile</h2>
        </div>
        <div className="profile-card">
          <div className="profile-field">
            <div className="field-icon">
              <User size={18} />
            </div>
            <div className="field-content">
              <span className="field-label">Name</span>
              <span className="field-value">{staff.name}</span>
            </div>
          </div>
          <div className="profile-field">
            <div className="field-icon">
              <Users size={18} />
            </div>
            <div className="field-content">
              <span className="field-label">Father's Name</span>
              <span className="field-value">{profileData.fatherName}</span>
            </div>
          </div>
          <div className="profile-field">
            <div className="field-icon">
              <Image size={18} />
            </div>
            <div className="field-content">
              <span className="field-label">Designation</span>
              <span className="field-value">{staff.post_name}</span>
            </div>
          </div>
          <div className="profile-field">
            <div className="field-icon">
              <CreditCard size={18} />
            </div>
            <div className="field-content">
              <span className="field-label">Aadhar Card Number</span>
              <span className="field-value">{staff.aadhar!='' ? staff.aadhar:"--"}</span>
            </div>
          </div>
          <div className="profile-field">
            <div className="field-icon">
              <Phone size={18} />
            </div>
            <div className="field-content">
              <span className="field-label">Mobile Number</span>
              <span className="field-value">{profileData.mobileNumber}</span>
            </div>
          </div>
          <div className="profile-field">
            <div className="field-icon">
              <DatabaseIcon size={18} />
            </div>
            <div className="field-content">
              <span className="field-label">Registration Date</span>
              <span className="field-value">{staff.reg_date}</span>
            </div>
          </div>
           
        </div>
      </div>
    </>
  );
};

export default StaffProfile;